import React, { ComponentType } from "react";
import { Button } from "antd";
import IMG500PNG from "../assets/500.png";
import { useNavigate } from "react-router-dom";
import "./index.less";
import { useTranslate } from "@obsbot/remo-i18n";
export interface AppRouteErrorBoundaryProps {
    Comp: ComponentType<any>;
    title: string;
}

export interface AppRouteErrorBoundaryState {
    hasError: boolean;
}

export class AppRouteErrorBoundary extends React.PureComponent<
    AppRouteErrorBoundaryProps,
    AppRouteErrorBoundaryState
> {
    public constructor(props: AppRouteErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    public static getDerivedStateFromError(): Partial<AppRouteErrorBoundaryState> {
        return { hasError: true };
    }

    public override componentDidCatch(error: any, errorInfo: any): void {
        console.error(error, errorInfo);
        // RemoServices.getInstance().shutdownAllServices();
    }

    // 新增一个方法来重置错误状态
    public resetError = (): void => {
        this.setState({ hasError: false });
    };

    public override render(): React.ReactNode {
        if (this.state.hasError) {
            // 将重置方法传递给 ErrorFallback 组件
            return <ErrorFallback resetErrorBoundary={this.resetError} state={this.state} />;
        }

        const { Comp } = this.props;

        return React.createElement(Comp);
    }
}

// 更新 ErrorFallback 的 props 类型并实现新的返回逻辑
const ErrorFallback: React.FC<{ state: any; resetErrorBoundary: () => void }> = ({
    state,
    resetErrorBoundary,
}) => {
    const navigate = useNavigate();
    const t = useTranslate();
    console.log("ErrorFallback", state);
    const toBack = (): void => {
        // 首先，重置错误边界的状态
        resetErrorBoundary();
        // 然后，安全地导航回上一个页面
        navigate(-1);
    };

    return (
        <div className="show-error-module">
            <img className="error-img" src={IMG500PNG} />
            <div className="error-desc">{t("error-page.page_error")}</div>
            <Button className="error-back-btn" type="primary" onClick={toBack}>
                {t("error-page.back")}
            </Button>
        </div>
    );
};

export default AppRouteErrorBoundary;
